import Vue from 'vue'

Vue.prototype.$handoverParams = url => {
  if (!!window) {
    const pageurl = new URL(location.href)
    const targeurl = new URL(/^\/+./.test(url) ? `${pageurl.origin}${url}` : url === '/' ? pageurl.origin : url)
    pageurl.searchParams.forEach((value, key) => {
      if ('cpno' || /utm_/.test(key)) {
        targeurl.searchParams.set(key, value)
      }
    })
    return targeurl.href
  } else {
    return url
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/scripts/handoverParams.js